import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import NoEngagements from "./NoEngagements";
import Awaiting from "./Awaiting";
import PendingInvitation from "./PendingInvitation";
import Engaged from "./Engaged";
import Disengaged from "./Disengaged";
import AgentsWrapper from "./styles/agents-styles";
import Updating from "../shared/loaders/Updating";
import FlashMessage from "../shared/general/FlashMessage";
import MessageAllAgencies from "./MessageAllAgencies";
import trackEvent from "../shared/ga/trackEvent";
import labels from "./labels";
import agentsType from "./types/agentsType";
import PreferredSupplier from "../../apiResources/PreferredSupplier";

class Agents extends Component {
  constructor(props) {
    super(props);
    const { agents } = this.props;
    const { awaiting, pendingInvitation, engaged, disengaged } = agents;

    this.state = {
      awaiting,
      pendingInvitation,
      engaged,
      disengaged,
      disengageModalShown: false,
      messageAllAgenciesModalShown: false,
      rejectModalShown: false,
      removeFromPslModalShown: false,
      disengagementMessage: "",
      messageAllAgenciesMessage: "",
      rejectMessage: "",
      removeFromPslMessage: "",
      loading: false,
      formLoading: false,
      flashMessage: "",
      showFlashMessage: false,
      showFlashMessageCloseButton: false,
      disengageUrl: "",
      disengageId: "",
      jobId: "",
      recruiterId: "",
      recruiterCompanyName: "",
      rejectUrl: "",
      rejectId: "",
      errors: {},
    };
  }

  componentDidMount() {
    document.body.classList.add("agents-tab");
  }

  componentWillUnmount() {
    document.body.classList.remove("agents-tab");
  }

  // accept engagement
  acceptOnClick = (acceptUrl) => {
    this.setState({ loading: true });

    axios
      .patch(acceptUrl)
      .then(({ data }) => {
        this.setState(({ awaiting, engaged }) => ({
          awaiting: awaiting.filter(
            (engagement) => engagement.engagementId !== data.id
          ),
          engaged: [data, ...engaged],
          loading: false,
        }));
        this.defineFlashMessage(data.accepted_engagements_count);

        trackEvent("engagements", "job hub agencies list", "accept");
      })
      .catch((response) => this.setState({ errors: response.data.errors }));
  };

  // reject engagement
  rejectOnClick = (rejectUrl, engagementId, jobId) => {
    const { rejectModalShown } = this.state;

    this.setState({
      rejectModalShown: !rejectModalShown,
      rejectUrl,
      rejectId: engagementId,
      jobId,
    });
  };

  setRejectMessage = (e) => {
    this.setState({
      rejectMessage: e.target.value,
    });
  };

  handleRejectOnSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });

    const { rejectUrl, rejectId, rejectMessage, jobId } = this.state;

    const payload = {
      url: rejectUrl,
      method: "patch",
      data: {
        engagement: { rejected_message: rejectMessage },
        id: rejectId,
        job_id: jobId,
      },
    };

    axios(payload)
      .then(({ data }) => {
        this.setState(({ awaiting, disengaged }) => ({
          awaiting: awaiting.filter(
            (engagement) => engagement.engagementId !== data.id
          ),
          disengaged: [...disengaged, data],
          rejectMessage: "",
          rejectModalShown: false,
          formLoading: false,
          showFlashMessage: true,
          flashMessage: "Successfully rejected",
          flashMessageIcon: "check",
          showFlashMessageCloseButton: false,
          errors: {},
        }));
        this.flashMessageHandle(3000);

        trackEvent("engagements", "job hub agencies list", "reject");
      })
      .catch((data) =>
        this.setState({
          errors: data.response.data.errors,
          formLoading: false,
        })
      );
  };

  closeRejectModal = (e) => {
    e.preventDefault();
    this.setState({
      rejectModalShown: false,
      rejectMessage: "",
      rejectUrl: "",
      rejectId: "",
      jobId: "",
      errors: {},
    });
  };

  // disengage
  disengageOnClick = (disengageUrl, engagementId, jobId) => {
    const { disengageModalShown } = this.state;
    this.setState({
      disengageModalShown: !disengageModalShown,
      disengageUrl,
      disengageId: engagementId,
      jobId,
    });
  };

  setDisengagementMessage = (e) => {
    this.setState({
      disengagementMessage: e.target.value,
    });
  };

  handleDisengageOnSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });

    const { disengageUrl, disengageId, disengagementMessage, jobId } =
      this.state;

    const payload = {
      url: disengageUrl,
      method: "put",
      data: {
        engagement: { disengagement_message: disengagementMessage },
        id: disengageId,
        job_id: jobId,
      },
    };

    axios(payload)
      .then(() => {
        this.setState(({ engaged, disengaged }) => {
          const data = engaged.find(
            (engagement) => engagement.engagementId === disengageId
          );

          return {
            engaged: engaged.filter(
              (engagement) => engagement.engagementId !== disengageId
            ),
            disengaged: [data, ...disengaged],
            disengagementMessage: "",
            disengageModalShown: false,
            formLoading: false,
            flashMessage: "Successfully disengaged",
            flashMessageIcon: "check",
            showFlashMessage: true,
            showFlashMessageCloseButton: false,
            errors: {},
          };
        });
        this.flashMessageHandle(3000);
      })
      .catch((data) =>
        this.setState({
          errors: data.response.data.errors,
          formLoading: false,
        })
      );
  };

  closeDisengageModal = (e) => {
    e.preventDefault();
    this.setState({
      disengageModalShown: false,
      disengagementMessage: "",
      errors: {},
      disengageUrl: "",
      disengageId: "",
      jobId: "",
    });
  };

  // add to PSL
  addToPslOnClick = async (recruiterId) => {
    const { employerId, employerUserId } = this.props;

    const preferredSupplier = new PreferredSupplier({
      employerId,
      employerUserId,
      recruiterId,
    });

    try {
      const success = await preferredSupplier.save();

      if (success) {
        this.setState(({ engaged }) => ({
          engaged: engaged.map((engagement) => {
            if (engagement.recruiterId === recruiterId) {
              return {
                ...engagement,
                psl: true,
              };
            }
            return engagement;
          }),
          flashMessage: "Successfully added to your PSL",
          flashMessageIcon: "check",
          showFlashMessage: true,
          showFlashMessageCloseButton: false,
        }));
        this.flashMessageHandle(3000);
      } else {
        this.setState({ errors: preferredSupplier.errors });
      }
    } catch (error) {
      this.setState({ errors: error });
    }
  };

  // remove from PSL
  removeFromPslOnClick = (recruiterId, jobId, recruiterCompanyName) => {
    const { removeFromPslModalShown } = this.state;
    this.setState({
      removeFromPslModalShown: !removeFromPslModalShown,
      recruiterId,
      jobId,
      recruiterCompanyName,
    });
  };

  setRemoveFromPslMessage = (e) => {
    this.setState({
      removeFromPslMessage: e.target.value,
    });
  };

  handleRemoveFromPslSubmit = async (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });

    const { recruiterId, removeFromPslMessage } = this.state;

    const preferredSupplier = (
      await PreferredSupplier.where({
        recruiter_id: recruiterId,
      }).all()
    ).data[0];

    preferredSupplier.message = removeFromPslMessage;

    await preferredSupplier.save();
    await preferredSupplier.destroy();

    this.setState(({ engaged }) => ({
      engaged: engaged.map((engagement) => {
        if (engagement.recruiterId === recruiterId) {
          return {
            ...engagement,
            psl: false,
          };
        }
        return engagement;
      }),
      formLoading: false,
      removeFromPslModalShown: false,
      removeFromPslMessage: "",
      recruiterId: "",
      jobId: "",
      recruiterCompanyName: "",
      flashMessage: "Successfully removed from your PSL",
      flashMessageIcon: "check",
      showFlashMessageCloseButton: false,
      showFlashMessage: true,
      errors: {},
    }));
    this.flashMessageHandle(3000);
  };

  closeRemoveFromPslModal = (e) => {
    e.preventDefault();
    this.setState({
      removeFromPslModalShown: false,
      removeFromPslMessage: "",
      recruiterId: "",
      jobId: "",
      recruiterCompanyName: "",
      errors: {},
    });
  };

  // message all agencies
  messageAllOnClick = () => {
    const { messageAllAgenciesModalShown } = this.state;
    this.setState({
      messageAllAgenciesModalShown: !messageAllAgenciesModalShown,
    });
  };

  setMessageAllAgenciesMessage = (e) => {
    this.setState({
      messageAllAgenciesMessage: e.target.value,
    });
  };

  handleMessageAllAgenciesSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });

    const { messageAllAgenciesMessage } = this.state;
    const { agents } = this.props;
    const { jobId, messageAllUrl } = agents;

    const payload = {
      url: messageAllUrl,
      method: "post",
      data: {
        message: {
          initial_message: messageAllAgenciesMessage,
        },
        job_id: jobId,
      },
    };

    axios(payload)
      .then(() => {
        this.setState({
          messageAllAgenciesMessage: "",
          messageAllAgenciesModalShown: false,
          formLoading: false,
          flashMessage: "Message successfully sent",
          flashMessageIcon: "check",
          showFlashMessage: true,
          showFlashMessageCloseButton: false,
          errors: {},
        });
        this.flashMessageHandle(3000);
      })
      .catch((data) =>
        this.setState({
          errors: data.response.data.errors,
          formLoading: false,
        })
      );
  };

  closeMessageAllAgenciesModal = () => {
    this.setState({
      messageAllAgenciesModalShown: false,
      messageAllAgenciesMessage: "",
      errors: {},
    });
  };

  defineFlashMessage = (acceptedEngagementsCount) => {
    const orange = "#FBB577";

    switch (acceptedEngagementsCount) {
      case 3:
        this.setState({
          showFlashMessage: true,
          flashMessageColour: orange,
          flashMessage: labels.engaging3agencies,
          flashMessageIcon: null,
          showFlashMessageCloseButton: true,
        });
        this.flashMessageHandle(15000);
        break;
      case 5:
        this.setState({
          showFlashMessage: true,
          flashMessageColour: orange,
          flashMessage: labels.engaging5agencies,
          flashMessageIcon: null,
          showFlashMessageCloseButton: true,
        });
        this.flashMessageHandle(15000);
        break;
      default:
        break;
    }
  };

  flashMessageHandle = (time) => {
    const { showFlashMessage } = this.state;

    if (showFlashMessage) {
      setTimeout(() => {
        this.setState({ showFlashMessage: false });
      }, time);
    }
  };

  closeFlashMessage = () => {
    this.setState({ showFlashMessage: false });
  };

  render() {
    const {
      awaiting,
      pendingInvitation,
      engaged,
      disengaged,
      loading,
      formLoading,
      disengageModalShown,
      rejectModalShown,
      messageAllAgenciesModalShown,
      removeFromPslModalShown,
      errors,
      showFlashMessage,
      flashMessage,
      flashMessageColour,
      flashMessageIcon,
      recruiterCompanyName,
      showFlashMessageCloseButton,
    } = this.state;

    const { isPortalEmployer } = this.props;

    return (
      <ErrorBoundary>
        <ReactTooltip
          html
          place="bottom"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="agents-page-tooltip"
        />
        <AgentsWrapper id="agents-wrapper">
          <FlashMessage
            message={flashMessage}
            showFlashMessage={showFlashMessage}
            backgroundColour={flashMessageColour}
            showFlashMessageCloseButton={showFlashMessageCloseButton}
            flashMessageIcon={flashMessageIcon}
            closeAction={this.closeFlashMessage}
          />
          <Updating loading={loading} />
          <MessageAllAgencies
            messageAllOnClick={this.messageAllOnClick}
            messageAllAgenciesModalShown={messageAllAgenciesModalShown}
            engaged={engaged}
            showFlashMessage={showFlashMessage}
            formLoading={formLoading}
            closeMessageAllAgenciesModal={this.closeMessageAllAgenciesModal}
            setMessageAllAgenciesMessage={this.setMessageAllAgenciesMessage}
            handleMessageAllAgenciesSubmit={this.handleMessageAllAgenciesSubmit}
            errors={errors}
          />
          {awaiting.length === 0 && <NoEngagements />}
          {awaiting.length > 0 && (
            <Awaiting
              agents={awaiting}
              acceptOnClick={this.acceptOnClick}
              rejectOnClick={this.rejectOnClick}
              handleRejectOnSubmit={this.handleRejectOnSubmit}
              rejectModalShown={rejectModalShown}
              closeRejectModal={this.closeRejectModal}
              setRejectMessage={this.setRejectMessage}
              formLoading={formLoading}
              errors={errors}
            />
          )}
          {isPortalEmployer && pendingInvitation.length > 0 && (
            <PendingInvitation agents={pendingInvitation} />
          )}
          {engaged.length > 0 && (
            <Engaged
              agents={engaged}
              addToPslOnClick={this.addToPslOnClick}
              disengageOnClick={this.disengageOnClick}
              disengageModalShown={disengageModalShown}
              setDisengagementMessage={this.setDisengagementMessage}
              handleDisengageOnSubmit={this.handleDisengageOnSubmit}
              closeDisengageModal={this.closeDisengageModal}
              removeFromPslOnClick={this.removeFromPslOnClick}
              removeFromPslModalShown={removeFromPslModalShown}
              setRemoveFromPslMessage={this.setRemoveFromPslMessage}
              handleRemoveFromPslSubmit={this.handleRemoveFromPslSubmit}
              closeRemoveFromPslModal={this.closeRemoveFromPslModal}
              recruiterCompanyName={recruiterCompanyName}
              formLoading={formLoading}
              errors={errors}
              isPortalEmployer={isPortalEmployer}
            />
          )}
          {disengaged.length > 0 && <Disengaged agents={disengaged} />}
        </AgentsWrapper>
      </ErrorBoundary>
    );
  }
}

Agents.propTypes = {
  agents: agentsType.isRequired,
  isPortalEmployer: PropTypes.bool.isRequired,
  employerId: PropTypes.number.isRequired,
  employerUserId: PropTypes.number.isRequired,
};

export default Agents;
